namespace Matrix.Workflow {
    @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerClass()
    export class RunBookGrid extends SiteEntityGrid<RunBookRow, any>{
        protected getColumnsKey() { return 'Workflow.RunBook'; }
        protected getDialogType() { return RunBookDialog; }
        protected getIdProperty() { return RunBookRow.idProperty; }
        protected getInsertPermission() { return RunBookRow.insertPermission; }
        protected getLocalTextPrefix() { return RunBookRow.localTextPrefix; }
        protected getService() { return RunBookService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            new Serenity.DraggableGroupingMixin({
                grid: this
            });
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            return opt;
        }

        protected getInitialTitle() {
            return "Runbook";
        }

        protected usePager() {
            return false;
        }
    }
}